
<div class="overlay-container" >
</div> 
<div class="modal show" id="myModal" >
 <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
       
          
            <div class="row no-margin">
                <div class="col-12 col-sm-12 mb-3" [innerHTML]="(megStoreService.configurationsData$ | async)?.megConfig?.serviceFeeDisclaimerText">
                    
                </div>
              </div>          
        </div>

    </div>
  </div>
</div>